import React from "react"
import icnHelpHeaderMsgngSrc from "./assets/images/icn-help-header-msgng.png"
import icnHelpHeaderMsgng2xSrc from "./assets/images/icn-help-header-msgng-2x.png"
import { useIntl } from "react-intl"
import { Typography, useTheme, Stack } from "@carrotfertility/carotene-core"

function DisclaimerMessageBubble({ messageDisclaimer }: { messageDisclaimer: string }): JSX.Element {
  const theme = useTheme()
  return (
    <Stack
      display="flex"
      direction="row"
      spacing={theme.spacing(theme.tokens.spacing.lg)}
      alignItems="start"
      paddingY={(theme) => theme.spacing(theme.tokens.spacing.lg)}
      paddingBottom={(theme) => theme.spacing(theme.tokens.spacing.xxxl)}
      marginBlockEnd={theme.spacing(theme.tokens.spacing.md)}
      borderBottom={(theme) => `${theme.tokens.borderWidth.sm} solid ${theme.palette.border.light}`}
    >
      <img src={icnHelpHeaderMsgngSrc} srcSet={`${icnHelpHeaderMsgng2xSrc} 2x`} alt="" height="40px" width="40px" />
      <Typography variant="body2" color={theme.palette.text.tertiary}>
        {messageDisclaimer}
      </Typography>
    </Stack>
  )
}

export function DisclaimerMessage(): JSX.Element {
  const intl = useIntl()
  const messagesDisclaimer = intl.formatMessage({
    defaultMessage:
      "Carrot resources are for informational purposes only and do not constitute medical advice or professional services. They are not a substitute for legal, tax, licensed clinical care, or professional medical advice, diagnosis, or treatment. If you are experiencing a medical emergency, call emergency services immediately."
  })
  return <DisclaimerMessageBubble messageDisclaimer={messagesDisclaimer} />
}
